<template>
  <div class="index" id="anchor">
    <Seacher></Seacher>
    <div class="verify">
      <div class="verifylist">
        <div class="verifytit">Verify & Publish Contract Source Code</div>
        <div class="verifycon">
          Contract verification is an impotant step through which you can
          confirm the authenticity and transparency of the smart contract you've
          writtenby validating it against the already deployed smart contract
          code on the blockchain network.You just need to upload your smart
          contract code toinitiate the verification process
        </div>
        <div class="verifybox">
          <el-form ref="form" :model="form" :rules="rules">
            <div class="verifyli">
              <div class="verifylitit">Contract Address :</div>
              <div class="verifylicon">
                <el-form-item prop="contractAddress">
                  <el-input v-model="form.contractAddress" class="inpttext"></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="verifyli">
              <div class="verifylitit">Contract Language :</div>
              <div class="verifylicon">
                <el-form-item prop="contractLanguage">
                  <el-input
                    v-model="form.contractLanguage"
                    :readonly="isReadOnly"
                    class="inpttext"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="verifyli">
              <div class="verifylitit">Compiler Version :</div>
              <div class="verifylicon">
                <el-form-item prop="compileVersion">
                  <el-select
                    v-model="form.compileVersion"
                    placeholder="Please select"
                    class="inpttext"
                  >
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="verifyli">
              <div class="verifylitit">License :</div>
              <div class="verifylicon">
                <el-form-item prop="licence">
                  <el-select
                    v-model="form.licence"
                    placeholder="Please select"
                    class="inpttext"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="verifyli">
              <div class="verifylitit">Contract Code :</div>
              <div class="verifylicona">
                <el-upload
                  accept=".sol, .txt, .text"
                  action="https://explorer.tfsc.io/tfscBrowser/contract/uploadSolFile"
                  :limit="1"
                  :before-upload="beforeUpload"
                  :on-success="upSuccess"
                  :on-error="upError"
                  ref="upload"
                >
                  <el-button size="small">
                    <span class="iconfont icon-shangchuan" />Upload Contract
                    File
                  </el-button>
                </el-upload>
              </div>
              <div class="verifyliconb">
                <el-form-item prop="sourceCode">
                  <el-input
                    type="textarea"
                    v-model="form.sourceCode"
                    :rows="16"
                  ></el-input>
                </el-form-item>
                <!-- <editor
                  v-model="form.sourceCode"
                  @init="editorInit"
                  @input="codeChange"
                  lang="java"
                  :options="editorOptions"
                  theme="vibrant_ink"
                ></editor> -->
              </div>
            </div>
            <div class="verifyli">
              <div class="verifylitit" style="word-spacing: -1px">
                Constructor Arguments ABI-encoded :
              </div>
              <div
                class="verifylitit"
                style="word-spacing: -1px; font-size: 12px !important"
              >
                (for contracts that were created with constructor parameters)
              </div>
              <div class="verifyliconb">
                <el-form-item prop="argumentsABIEncode">
                  <el-input
                    type="textarea"
                    v-model="form.argumentsABIEncode"
                    :rows="8"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="verifyli" v-show="flog">
              <div class="verifylierror">
                <img :src="imgnamef" />
                <div>{{ error }}</div>
                <!-- <div>
                  Error! Unable to locate ContractCode
                  at {{ form.contractAddress }} Is this a valid
                  Contract Address?
                </div> -->
              </div>
            </div>
            <div class="verifyli">
              <!-- <div class="verifylitit">License :</div> -->
              <div class="verfery_btna" @click.once ="submitForm">
                Verify And Publish
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatSeconds, getSubStr } from "@/utils/utils";
import Seacher from "@/components/m/Seacher.vue";
import { BlockList, GetBlockList } from "../../assets/server/api.js";
import Editor from "vue2-ace-editor";
import axios from "axios";
//黑底色
import "brace/theme/tomorrow_night_eighties";
//蓝底色
import "brace/theme/tomorrow_night_blue";
//黑底色
import "brace/theme/vibrant_ink";
export default {
  components: {
    Seacher,
    Editor,
  },
  data() {
    return {
      error:'',
      isReadOnly: true,
      flog:false,
      isDisabled:false,
      imgnamef: require("@/assets/pc/TopValidators/fail.png"),
      form: {
        contractAddress: "", //第一个名字
        contractLanguage: "Solidity",
        sourceCode: "",
        compileVersion: "",
        licence: "",
        // lastName: "", //最后一个名字
      },
      rules: {
        contractAddress: [
          {
            required: true,
            message: "Contract Address  is required",
            trigger: "blur",
          },
          { min: 30, max: 45, message: " Contract address error", trigger: "blur" },
        ],

        compileVersion: [
          {
            required: true,
            message: "Contract Version  is required",
            trigger: "change",
          },
        ],
        licence: [
          {
            required: true,
            message: "licence  is required",
            trigger: "change",
          },
        ],
        sourceCode: [
          {
            required: true,
            message: "Contract Code   is required",
            trigger: "change",
          },
        ],
      },
      options: [
        {
          value: "No License (None)",
          label: "1) No License (None)",
        },
        {
          value: "The Unlicense (Unlicense)1",
          label: "2) The Unlicense (Unlicense)",
        },
        {
          value: "MIT License (MIT)",
          label: "3) MIT License (MIT)",
        },
        {
          value: "GNU General Public License v2.0 (GNU GPLv2",
          label: "4) GNU General Public License v2.0 (GNU GPLv2",
        },
        {
          value: "GNU General Public License v3.0 (GNU GPLv3)",
          label: "5) GNU General Public License v3.0 (GNU GPLv3)",
        },
        {
          value: "GNU Lesser General Public License v2.1 (GNU LGPLv2.1)",
          label: "6) GNU Lesser General Public License v2.1 (GNU LGPLv2.1)",
        },
        {
          value: "GNU Lesser General Public License v3.0 (GNU LGPLv3)",
          label: "7) GNU Lesser General Public License v3.0 (GNU LGPLv3)",
        },
        {
          value: "BSD 2-clause 'Simplified' license (BSD-2-Clause)",
          label: "8) BSD 2-clause 'Simplified' license (BSD-2-Clause)",
        },
        {
          value: 'BSD 3-clause "New" Or "Revised" license (BSD-3-Clause)',
          label: '9) BSD 3-clause "New" Or "Revised" license (BSD-3-Clause)',
        },
        {
          value: "Mozilla Public License 2.0 (MPL-2.0)",
          label: "10) Mozilla Public License 2.0 (MPL-2.0)",
        },
        {
          value: "Open Software License 3.0 (OSL-3.0)",
          label: "11) Open Software License 3.0 (OSL-3.0)",
        },
        {
          value: "Apache 2.0 (Apache-2.0)",
          label: "12) Apache 2.0 (Apache-2.0)",
        },
        {
          value: "GNU Affero General Public License (GNU AGPLv3)",
          label: "13) GNU Affero General Public License (GNU AGPLv3)",
        },
        {
          value: "Business Source License (BSL 1.1)",
          label: "14) Business Source License (BSL 1.1)",
        },
      ],
      options1: [
        {
          value: "0821",
          label: "v0.8.21+commit.d9974bed",
        },
        {
          value: "0820",
          label: "v0.8.20+commit.a1b79de6",
        },
        {
          value: "0819",
          label: "v0.8.19+commit.7dd6d404",
        },
        {
          value: "0818",
          label: "v0.8.18+commit.87f61d96",
        },
        {
          value: "0817",
          label: "v0.8.17+commit.8df45f5f",
        },
        {
          value: "0816",
          label: "v0.8.16+commit.07a7930e",
        },
        {
          value: "0815",
          label: "v0.8.15+commit.e14f2714",
        },
        {
          value: "0814",
          label: "v0.8.14+commit.80d49f37",
        },
        {
          value: "0813",
          label: "v0.8.13+commit.abaa5c0e",
        },
        {
          value: "0812",
          label: "v0.8.12+commit.f00d7308",
        },
        {
          value: "0811",
          label: "v0.8.11+commit.d7f03943",
        },
        {
          value: "0810",
          label: "v0.8.10+commit.fc410830",
        },
        {
          value: "089",
          label: "v0.8.9+commit.e5eed63a",
        },
        {
          value: "088",
          label: "v0.8.8+commit.dddeac2f",
        },
        {
          value: "087",
          label: "v0.8.7+commit.e28d00a7",
        },
        {
          value: "086",
          label: "v0.8.6+commit.11564f7e",
        },
        {
          value: "085",
          label: "v0.8.5+commit.a4f2e591",
        },
        {
          value: "084",
          label: "v0.8.4+commit.c7e474f2",
        },
        {
          value: "083",
          label: "v0.8.3+commit.8d00100c",
        },
        {
          value: "082",
          label: "v0.8.2+commit.661d1103",
        },
        {
          value: "081",
          label: "v0.8.1+commit.df193b15",
        },
        {
          value: "080",
          label: "v0.8.0+commit.c7dfd78e",
        },
        {
          value: "076",
          label: "v0.7.6+commit.7338295f",
        },
        {
          value: "075",
          label: "v0.7.5+commit.eb77ed08",
        },
        {
          value: "074",
          label: "v0.7.4+commit.3f05b770",
        },
        {
          value: "073",
          label: "v0.7.3+commit.9bfce1f6",
        },
        {
          value: "072",
          label: "v0.7.2+commit.51b20bc0",
        },
        {
          value: "071",
          label: "v0.7.1+commit.f4a555be",
        },
        {
          value: "070",
          label: "v0.7.0+commit.9e61f92b",
        },
        {
          value: "0612",
          label: "v0.6.12+commit.27d51765",
        },
        {
          value: "0611",
          label: "v0.6.11+commit.5ef660b1",
        },
        {
          value: "0610",
          label: "v0.6.10+commit.00c0fcaf",
        },
        {
          value: "069",
          label: "v0.6.9+commit.3e3065ac",
        },
        {
          value: "068",
          label: "v0.6.8+commit.0bbfe453",
        },
        {
          value: "067",
          label: "v0.6.7+commit.b8d736ae",
        },
        {
          value: "066",
          label: "v0.6.6+commit.6c089d02",
        },
        {
          value: "065",
          label: "v0.6.5+commit.f956cc89",
        },
        {
          value: "064",
          label: "v0.6.4+commit.1dca32f3",
        },
        {
          value: "063",
          label: "v0.6.3+commit.8dda9521",
        },
        {
          value: "062",
          label: "v0.6.2+commit.bacdbe57",
        },
        {
          value: "061",
          label: "v0.6.1+commit.e6f7d5a4",
        },
        {
          value: "060",
          label: "v0.6.0+commit.26b70077",
        },
        {
          value: "0517",
          label: "v0.5.17+commit.d19bba13",
        },
        {
          value: "0516",
          label: "v0.5.16+commit.9c3226ce",
        },
        {
          value: "0515",
          label: "v0.5.15+commit.6a57276f",
        },
        {
          value: "0514",
          label: "v0.5.14+commit.01f1aaa4",
        },
        {
          value: "0513",
          label: "v0.5.13+commit.5b0b510c",
        },
        {
          value: "0512",
          label: "v0.5.12+commit.7709ece9",
        },
        {
          value: "v0511",
          label: "v0.5.11+commit.22be8592",
        },
        {
          value: "0511",
          label: "v0.5.11+commit.c082d0b4",
        },
        {
          value: "0510",
          label: "v0.5.10+commit.5a6ea5b1",
        },
        {
          value: "v059",
          label: "v0.5.9+commit.c68bc34e",
        },
        {
          value: "059",
          label: "v0.5.9+commit.e560f70d",
        },
        {
          value: "058",
          label: "v0.5.8+commit.23d335f2",
        },
        {
          value: "057",
          label: "v0.5.7+commit.6da8b019",
        },
        {
          value: "056",
          label: "v0.5.6+commit.b259423e",
        },
        {
          value: "055",
          label: "v0.5.5+commit.47a71e8f",
        },
        {
          value: "054",
          label: "v0.5.4+commit.9549d8ff",
        },
        {
          value: "053",
          label: "v0.5.3+commit.10d17f24",
        },
        {
          value: "052",
          label: "v0.5.2+commit.1df8f40c",
        },
        {
          value: "051",
          label: "v0.5.1+commit.c8a2cb62",
        },
        {
          value: "050",
          label: "v0.5.0+commit.1d4f565a",
        },
        {
          value: "0426",
          label: "v0.4.26+commit.4563c3fc",
        },
        {
          value: "0425",
          label: "v0.4.25+commit.59dbf8f1",
        },
        {
          value: "0424",
          label: "v0.4.24+commit.e67f0147",
        },
        {
          value: "0423",
          label: "v0.4.23+commit.124ca40d",
        },
        {
          value: "0422",
          label: "v0.4.22+commit.4cb486ee",
        },
        {
          value: "0421",
          label: "v0.4.21+commit.dfe3193c",
        },
        {
          value: "0420",
          label: "v0.4.20+commit.3155dd80",
        },
        {
          value: "0419",
          label: "v0.4.19+commit.c4cbbb05",
        },
        {
          value: "0418",
          label: "v0.4.18+commit.9cf6e910",
        },
        {
          value: "0417",
          label: "v0.4.17+commit.bdeb9e52",
        },
        {
          value: "0416",
          label: "v0.4.16+commit.d7661dd9",
        },
        {
          value: "v0415",
          label: "v0.4.15+commit.8b45bddb",
        },
        {
          value: "0415",
          label: "v0.4.15+commit.bbb8e64f",
        },
        {
          value: "0414",
          label: "v0.4.14+commit.c2215d46",
        },
        {
          value: "0413",
          label: "v0.4.13+commit.0fb4cb1a",
        },
        {
          value: "0412",
          label: "v0.4.12+commit.194ff033",
        },
        {
          value: "0411",
          label: "v0.4.11+commit.68ef5810",
        },
      ],
      editorOptions: {
        // 设置代码编辑器的样式
        wrap: true,
        // 设置代码编辑器的样式
        enableBasicAutocompletion: true, //启用基本自动完成
        enableSnippets: true, // 启用代码段
        //  enableLiveAutocompletion: true, //启用实时自动完成
        tabSize: 0, //标签大小
        fontSize: 14, //设置字号
        readOnly: true,
        showPrintMargin: false, //去除编辑器里的竖线
        wrapBehavioursEnabled: true, //启用换行
        autoScrollEditorIntoView: false, //启用滚动
        showFoldWidgets: true, // 显示折叠部件
        fadeFoldWidgets: true, // 淡入折叠部件
      },
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // async submitForm() {
    //   this.isDisabled = true;
    //   this.$refs.form.validate(async (success) => {
    //     if (success) {
    //       if (this.form.sourceCode.length > 0) {
    //         this.$refs.form.sourceCode.resetFields();
    //         axios
    //           .post(
    //             "https://explorer.tfsc.io/tfscBrowser/home/vertifyContract",
    //             this.form,
    //             {
    //               headers: {
    //                 "Content-Type": "application/json",
    //               },
    //             }
    //           )
    //           .then((res) => {
    //             // 请求成功状态为200说明添加成功
    //             console.log(res);
    //             console.log(res.data.code);
    //             console.log(res.data.result);
    //             if (res.data.code == 200) {
    //               console.log(res.code);
    //               this.flog=false;
    //               this.isDisabled = false;
    //               this.$router.push("/m/sucess");
                  
    //                this.$refs.form.resetFields();
    //               // // 关闭用户新增表单弹窗
    //               //  this.dialogFormVisible=false,
    //               //  // 添加成功提示
    //               // this.$message({showClose: true, message: '添加成功！',type: 'success', duration:2000,center:true});
    //               // // 重新刷新列表数据
    //               // this.queryUserList();
    //             } else  {
    //               this.flog=true;
    //               this.$refs.form.resetFields();
    //               //this.$refs.form.resetFields();
    //               return false;
                  
    //              // alert(1111);
    //               // this.$message({showClose: true, message: res.result,type: 'error', duration:2000,center:true});
    //             }
    //           })
    //           .catch((error) => {
    //             console.log(error);
    //             this.$message(" This field are not filled in ");
    //           });
    //       } else {
    //         this.$message("Contract Code   is required");
    //         return false;
    //       }
    //     } else {
    //       this.$message(" This field are not filled in ");
    //       return false;
    //     }
    //   });
    // },

    async submitForm() {
      this.$refs.form.validate(async (success) => {
        if (success) {
          if (this.form.sourceCode.length > 0) {
            axios
              .post(
                "https://explorer.tfsc.io/tfscBrowser/home/vertifyContract",
                this.form,
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((res) => {
                // 请求成功状态为200说明添加成功
              // console.log(res);

                if (res.data.code === 200) {
                  this.$router.push("/m/sucess");
                  this.flog=false;
                  // // 关闭用户新增表单弹窗
                  //  this.dialogFormVisible=false,
                  //  // 添加成功提示
                  // this.$message({showClose: true, message: '添加成功！',type: 'success', duration:2000,center:true});
                  // // 重新刷新列表数据
                  // this.queryUserList();
                } else {
                  this.error=res.data.result;
                  this.flog=true;
                  this.$refs.form.resetFields();
                  return false;
                  // alert(1111);
                  // this.$message({showClose: true, message: res.result,type: 'error', duration:2000,center:true});
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            this.$message("Contract Code   is required");
            return false;
          }
        } else {
          this.$message(" This field are not filled in ");
        //  this.$refs.form.resetFields();
          return false;
        }
      });
    },
    // 上传文件之前
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);

      const whiteList = ["sol", "txt", "text"];

      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$msg("上传文件只能是 pdf、doc、docx、xls、xlsx格式", "error");
        this.$message("File uploads must be in the sol、txt format.");
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message("File uploads must not exceed 2MB in size.", "error");
        return false;
      }
    },
    // 上传成功
    upSuccess(res, file) {
      this.$refs.upload.clearFiles();
      this.jsonfileName = file.name;
      this.uploadSuccess = true;
      // let val=''
      let reader = new FileReader();
      reader.readAsText(file.raw, "UTF-8"); //读取，转换字符编码
      let vm = this;
      reader.onload = function (e) {
        vm.form.sourceCode = e.target.result; //获取数据
      // console.log(vm.form.sourceCode);
        // if(vm.checkJSON(val)){
        //   vm.uploadSuccess=true
        //   vm.ruleForm.customRules=val
        // }else{
        //   vm.uploadSuccess=false
        //   vm.ruleForm.customRules=''
        //   vm.$message.error("JSON格式不符合规范");
        // }
      };
      // if (this.ruleForm.customRules) {
      //   this.$nextTick(()=>{
      //     this.$refs.ruleForm.clearValidate(["customRules"]);
      //   })
      // }
    },

    // 上传失败
    upError(e) {
      this.$message("上传失败", "error");
    },
    codeChange(val) {
      val; //console.log(val)
    },
    editorInit() {
      require("brace/theme/chrome");
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/yaml");
      require("brace/mode/json");
      require("brace/mode/less");
      require("brace/snippets/json");
      require("brace/mode/lua");
      require("brace/snippets/lua");
      require("brace/mode/javascript");
      require("brace/snippets/javascript");
      require("brace/mode/python");
    },
  },
  watch: {
    $route: {
      handler(val, oldval) {},
      deep: true,
    },
  },
};
</script>
<style lang="less">
.el-message {
  margin-top: 120px !important;
}
::-webkit-scrollbar {
  width: 0px !important; /*滚动条宽度*/
  height: 8px; /*滚动条高度*/
}
.el-textarea__inner::-webkit-scrollbar-thumb {
  background-color: rgba(168, 168, 168, 0.4); /*滚动条默认显示的颜色*/
}

.el-textarea__inner::-webkit-scrollbar {
  width: 0px !important;
  height: 8px;
  background-color: white; /*滚动条背景色显示的颜色*/
}
input {
  border: none;
}
.el-textarea__inner {
  border: none !important;
  /* width: 806px; */
  /* height: 341px; */
  background: #13161b !important;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  /* color: #fff !important; */
  /* margin-left: 150px */
}


.el-upload-list {
  display: none !important;
}
button:hover {
  color: #06c083 !important;
}
.el-select-dropdown__list {
  background-color: #13161b !important;
  border: none !important;
  // padding-left: 30px;
}
.el-select-dropdown {
  border: none;
}
.el-select-dropdown__item.hover {
  background-color: #000 !important;
}
.el-select-dropdown__item.selected {
  color: #06c083;
}
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #13161b;
}
.el-scrollbar__wrap{
  // border: 1px solid red !important;
  width: 660px !important;
}

.el-select-dropdown__list{
  // margin-left: 30px;
}
.el-select-dropdown__item{
  padding-left:30px;
  // margin-left: 30px;
}
</style>

<style lang="less" scoped>
/deep/.el-button {
  background-color: #13161b !important;
  border: none !important;
  color: #fff;
}
/deep/.el-input__inner {
  background-color: #13161b !important;
  border: none !important;
  width: 654px;
  height: 84px;

  border-radius: 12px 12px 12px 12px;
  opacity: 1;
}
.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;

  .verify {
    width: 702px;
    margin: 0 auto;
    height: 2712px;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;

    .verifylist {
      width: 702px;
      height: 2712px;
      background: #0b0c0f;
      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      margin: 0 auto;
      text-align: left;
      .verifytit {
        margin-left: 24px;
        padding-top: 24px;
        height: 35px;
        font-size: 30px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 35px;
      }
      .verifycon {
        margin-left: 24px;
        padding-top: 40px;
        height: 216px;
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #898b8d;
        line-height: 36px;
      }
    }
    .verifybox {
      padding-top: 58px;
      margin-left: 24px;
      .verifyli {
        margin-top: 58px;
        .verifylierror {
          display: flex;
          width: 654px;
          height: 133px;
          background: rgba(206, 53, 75, 0.1);
          border-radius: 12px 12px 12px 12px;
          opacity: 1;
          img {
            width: 48px;
            height: 48px;
            margin-left: 28px;
            margin-top: 43px;
          }
          div {
            font-size: 24px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #ff3d59;
            line-height: 31px;
            margin-top: 20px;
            margin-left: 27px;
            margin-right: 5px;
          }
        }
        .verifylitit {
          height: 30px;
          font-size: 26px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #898b8d;
          line-height: 30px;
        }
        .verifylicon {
          margin-top: 20px;
          width: 654px;
          height: 84px;
          background: #13161b;
          border-radius: 12px 12px 12px 12px;
          opacity: 1;
          .inpttext{
            //border: 1px solid red !important;
          }
        }
        .verifyliconb {
          margin-top: 20px;
          width: 654px;
          // height: 568px;
          background: #13161b;
          border-radius: 12px 12px 12px 12px;
          opacity: 1;
        }
        .verifylicona {
          margin-top: 20px;
        }
        .verfery_btna {
          width: 654px;
          height: 80px;
          background: #13161b;
          border-radius: 12px 12px 12px 12px;
          opacity: 1;
          line-height: 80px;
          text-align: center;
          font-size: 26px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.9);
        }
      }
    }
  }
}
</style>
